import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Paginate from './Pagination';
import { useHistory } from 'react-router-dom';

const DashboardOrderList = (props: any) => {
  const history = useHistory();
  const { orders } = props;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;

  useEffect(() => {
    const updateWindowDimension = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateWindowDimension);
    return () => {
      window.removeEventListener('resize', updateWindowDimension);
    };
  }, []);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSignleOrder = (item) => {
    history.push(`/dashboard/order-details/${item.orderid}`);
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentOrders = orders.userOrders.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <div>
      <table className="table">
        <thead className="table-borderless">
          <tr>
            <th scope="col">ORDER NO</th>
            {windowWidth > 600 && <th scope="col">PAYMENT TYPE</th>}
            <th scope="col">ORDER DATE</th>
            {windowWidth > 600 && (
              <React.Fragment>
                <th scope="col">TOTAL</th>
              </React.Fragment>
            )}
            <th scope="col">ORDER STATUS</th>
            <th scope="col">SHIPPING DATE</th>
          </tr>
        </thead>
        <tbody>
          {currentOrders.map((item) => (
            <tr key={item._id} className="user_order_item" onClick={() => handleSignleOrder(item)}>
              <td
                className="text-truncate"
                style={{
                  color: 'rgb(222,66,81)',
                  verticalAlign: 'middle',
                  maxWidth: windowWidth < 600 && '50px',
                }}
              >
                {item.orderid.toUpperCase()}
              </td>
              {windowWidth > 600 && (
                <td style={{ verticalAlign: 'middle' }}>
                  {item.paymentType === 'stripe'
                    ? 'Credit Card '
                    : item.paymentType === 'paypal' && 'Paypal'}
                </td>
              )}
              <td style={{ verticalAlign: 'middle' }}>{moment(item.created_at).format('LLL')}</td>

              {windowWidth > 600 && (
                <td
                  style={{ verticalAlign: 'middle', width: '100px' }}
                  className="font-weight-bold text-muted"
                >
                  AUD {(item.total / 100).toFixed(2)}
                </td>
              )}
              <td
                className={item.orderStatus === 'Processing' ? 'text-warning' : 'text-success'}
                style={{ verticalAlign: 'middle' }}
              >
                {item.orderStatus}
              </td>
              <td
                className={item.shippingDate && 'text-success'}
                style={{ verticalAlign: 'middle' }}
              >
                {item.shippingDate
                  ? moment(item.shippingDate).format('LL')
                  : item.shippingType === 'pickup'
                    ? 'Pick up'
                    : 'N/A'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-center">
        {orders.userOrders.length !== 0 && orders.userOrders.length > 5 && (
          <Paginate
            postsPerPage={postsPerPage}
            totalPosts={orders.userOrders.length}
            paginate={paginate}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
  fullPageLoading: state.fullPageLoading,
  orders: state.orders,
});

export default connect(mapStateToProps, {})(DashboardOrderList);
